/* eslint-disable camelcase */
import React, { memo } from 'react';

import cx from 'classnames';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { getFormattedVolume } from 'helpers/utils';
import { statsSelector } from 'selectors';
// import { VolumeIcon } from 'styles/assets/icons';
import { useAppSelector } from 'storeHooks';

import styles from './volume.module.scss';

const OptionsVolumeBox = ({ withBg }: { withBg: boolean }) => {
  const allStats = useAppSelector(statsSelector);
  const options_last_24h_volume =
    allStats.options && allStats.options.last_24h_volume
      ? allStats.options.last_24h_volume
      : null;

  const { t } = useTranslation(['markets']);

  return (
    (<div
      className={cx(styles.totalVolumeBox, {
        [styles.coloredBox]: withBg,
      })}
      data-palette="OptionsVolumeBox">
      {/* <VolumeIcon /> */}
      <span>
        <span className={styles.secondaryText}>
          24 hr {t('markets:marketsTable.volume')}
        </span>
        {options_last_24h_volume === null || options_last_24h_volume === 0
          ? ' ---'
          : ` $${getFormattedVolume(isMobile)(options_last_24h_volume)}`}
      </span>
    </div>)
  );
};

export default memo(OptionsVolumeBox);
